import gql from 'graphql-tag';

export function listLoadSheetLoadsQuery() {
  return gql(`
    query ListLoadSheetLoads($mobileUserConfigType: String!) {
      loadSheetLoads: listLoadSheetLoads(mobileUserConfigType: $mobileUserConfigType) {
        id
        date
        releaseDate
        stagingReleaseDate
        completeDate
        vehicle {
          id
          registration
          name
        }
        externalVehicle {
          id
          registration
          make
          model
        }
        wave {
          id
          waveConfig {
            id
            waveName
          }
        }
        loadBay {
          id
          name
        }
        pickingItems {
          id
          pickStatus
        }
        stagingItems {
          id
          stageStatus
        }
        availablePickCount
        orders {
          id
          orderCode
          customer {
            name
          }
        }
      }
    }
  `);
}
